<div [class]="name" (click)="changeMood()">{{name}}</div>
